import {
	ChangeDetectionStrategy,
	Component,
	Directive,
	HostBinding,
	Input,
	NgModule,
} from '@angular/core';

@Directive({
	standalone: false,
	selector: '[sameWidthTextItem]',
})
export class SameWidthTextItemDirective {
	@HostBinding('attr.sameWidthTextItemValue')
	@Input()
	public sameWidthTextItem: 'visible' | 'hidden' = 'hidden';
}

@Component({
	standalone: false,

	selector: 'same-width-text, [sameWidthText]',
	templateUrl: './same-width-text.component.html',
	styleUrls: ['./same-width-text.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SameWidthTextComponent {
	@Input('sameWidthText')
	public direction: 'horizontal' | 'vertical' = 'horizontal';

	@HostBinding('class')
	public get directionClass(): string {
		return `DIRECTION-${this.direction}`;
	}
}

@NgModule({
	declarations: [SameWidthTextComponent, SameWidthTextItemDirective],
	exports: [SameWidthTextComponent, SameWidthTextItemDirective],
})
export class SameWidthTextModule {}
